import React, { useEffect, useState } from "react";
import { Zap } from "lucide-react";
import { api } from "@/lib/api";

/**
 * Slim auto-scrolling news ticker bar. Only renders items where
 * is_breaking = true. Sits below the gold category ticker.
 */
export default function NewsTicker() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api
      .get("/news")
      .then((r) => setItems((r.data || []).filter((i) => i.is_breaking)))
      .catch(() => setItems([]));
  }, []);

  if (items.length === 0) return null;

  const doubled = [...items, ...items];

  return (
    <div
      className="relative border-y border-[var(--border)] bg-[var(--bg)] overflow-hidden"
      data-testid="news-ticker"
    >
      {/* Sticky "Latest" label on the left */}
      <div className="absolute left-0 top-0 bottom-0 z-10 flex items-center gap-2 px-4 bg-[var(--gold)] text-[var(--bg)] font-mono text-[10px] uppercase tracking-[0.2em] font-bold">
        <Zap size={12} />
        Latest
      </div>

      <div className="news-ticker-track">
        {doubled.map((n, i) => (
          <a
            key={`${n.id}-${i}`}
            href={n.link || "#"}
            target={n.link ? "_blank" : undefined}
            rel={n.link ? "noopener noreferrer" : undefined}
            className="news-ticker-item"
            data-testid={`news-ticker-item-${i}`}
          >
            {n.category && (
              <span className="news-ticker-cat">{n.category}</span>
            )}
            <span className="news-ticker-headline">{n.headline}</span>
            <span className="news-ticker-dot">·</span>
          </a>
        ))}
      </div>
    </div>
  );
}
